import React, { useMemo } from 'react';
import {
  getPdfFilename,
  PDFGenerationStatus,
} from 'src/components/selfService/features/OrderHistory/OrderHistory.utils';
import { IOrdersReceipt } from 'src/types/OrderHistory';
import { usePdfStatus } from 'src/components/selfService/features/OrderHistory/hooks/usePdfStatus';
import { DownloadStateButton } from './DownloadStateButton';
import { FetchingState } from './FetchingState';
import { GenerateErrorState } from './GenerateErrorState';
import { GenerateStateButton } from './GenerateStateButton';

interface IPdfButtonProps {
  corpId: string;
  orderId: string;
  order: IOrdersReceipt;
}

export function PdfButton({
  corpId,
  orderId,
  order,
}: IPdfButtonProps): JSX.Element {
  const filename = useMemo(() => getPdfFilename(order), [order]);

  const { status, downloadUrl, generatePdf, setStatus } = usePdfStatus({
    corpId,
    orderId,
    filename,
  });

  const onErrorCloseHandle = () => {
    setStatus(PDFGenerationStatus.GENERATE);
  };

  switch (status) {
    case PDFGenerationStatus.GENERATE:
      return <GenerateStateButton onClick={generatePdf} />;
    case PDFGenerationStatus.FETCHING:
      return <FetchingState />;
    case PDFGenerationStatus.DOWNLOAD:
      return (
        <DownloadStateButton
          downloadUrl={downloadUrl}
          filename={filename}
          onError={() => setStatus(PDFGenerationStatus.ERROR)}
        />
      );
    case PDFGenerationStatus.ERROR:
      return <GenerateErrorState onErrorClose={onErrorCloseHandle} />;
    // For displaying empty space in brief moments such as page loads
    case PDFGenerationStatus.IDLE:
      return <></>;
    default:
      return <></>;
  }
}
